module.exports = __webpack_public_path__ + "static/media/play_icon.27e32e39.svg";